import '../DeckNav.css';
import DeckNav from "../DeckNav";
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
import Footer from '../../Components/Footer/Footer';
//one folder up so use ../
//if two folders away use ../../
import {VowelDeckFace} from "../../DeckCardOverviews/Phonetics/PhoneticsOv";
import SPLoader from '../../Components/Spinner/SpinnerLoader';

export default function VowelsNav() {
  return (
  <div>
    <SPLoader time={0.2}/>
    <HeaderNav GoBack_to={"/"}/>
    <DeckNav faceCard={VowelDeckFace} title_input="Vowels"/> 
    <Footer/>
   </div>
  )
}
